module.exports = __webpack_public_path__ + "img/details_logo.c47815f1.svg";